import { useCurrentUserContext } from '@/contexts';
import type { CollectionBase } from '@/features/events/types';
import { useIsExtension } from '@/features/magic/hooks/useIsExtension';
import type { LaunchOption, LaunchParams } from '@/hooks/useLauncher';
import { getLaunchParams } from '@/hooks/useLauncher/util';
import { useExtensionPopup } from '@/pages/QuickCreate/components/GoogleCalendar/hooks/useExtensionPopup';
import { getAuthUrl } from '@/pages/QuickCreate/components/GoogleCalendar/util';

type Options = {
  launchOnRedirect?: LaunchOption;
  redirectParams?: LaunchParams;
  email?: string;
  forEntryId?: string;
  base?: CollectionBase;
};

export const useCalendarAuth = ({
  launchOnRedirect,
  redirectParams,
  email,
  base,
}: Options = {}) => {
  const { currentUser } = useCurrentUserContext();
  const { isExtension } = useIsExtension();
  const { onAuth: handlePopupAuth } = useExtensionPopup();

  const handleCalendarAuth = ({
    forEntryId,
    ...options
  }: Omit<Options, 'base'> = {}) => {
    const launch = options.launchOnRedirect || launchOnRedirect;
    const params = options.redirectParams || redirectParams;
    const suggestedEmail = options.email || email;

    if (isExtension) {
      return handlePopupAuth({
        launch,
        launchParams: params && getLaunchParams(params),
        email: suggestedEmail,
        forEntryId,
      });
    }

    const query: Record<string, string> = { ...params };
    if (launch) {
      query.launch = launch;
    }

    window.location.href = getAuthUrl(
      currentUser,
      { email: suggestedEmail },
      base,
      query
    );
  };

  return {
    handleCalendarAuth,
  };
};
